import { useEffect, useState } from 'react';
import { fetchWrapper } from '../../../../_helpers';
import { Alert, Button, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import ComponentErrorBoundary from '@/Layouts/ComponentErrorBoundary';

const Component = ({ channelId, teamId, onUnlinkSuccess = () => {} }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [unlinking, setUnlinking] = useState(null);

    const loadChannelDetails = async () => {
        try {
            setLoading(true);
            const res = await fetchWrapper.get(`/chatrooms/${channelId}?team=${teamId}&populateEmployee=true`);
            setData(res);
        } catch (err) {
            if (err?.name === 'AbortError') return;
            console.error(err);
            toast.error('Unable to load channel details');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!channelId) return;
        loadChannelDetails();
    }, [channelId, teamId]);

    const unlink = async (type) => {
        try {
            setUnlinking(type);

            await fetchWrapper.patch(`/chatrooms/${channelId}/unlink-evv?team=${teamId}`, {
                target: type,
            });

            toast.success(`${type} unlinked`);
            setData((prev) => ({ ...prev, [type]: null }));
            onUnlinkSuccess();
            loadChannelDetails();
        } catch (err) {
            console.error(err);
            toast.error(err?.message || 'Failed to unlink');
        } finally {
            setUnlinking(null);
        }
    };

    if (loading) return <Spinner animation="border" />;

    if (!data?.client && !data?.employee) return null;

    return (
        <div className="mt-4  p-3 rounded">
            <Alert variant="warning">
                <Alert.Heading>
                    <div style={{ marginBottom: '3rem' }}>
                        Linked Entities on Channel: "<strong>{data.title || ''}</strong>"
                    </div>
                </Alert.Heading>
                {data.client && (
                    <div className="d-flex justify-content-between align-items-center mb-2 mt-2">
                        <div>
                            <strong>Client:</strong> {data.client.firstname} {data.client.lastname}
                        </div>
                        <Button
                            variant="outline-danger"
                            size="sm"
                            disabled={unlinking === 'client'}
                            onClick={() => unlink('client')}
                        >
                            {unlinking === 'client' ? '...' : 'Unlink Client'}
                        </Button>
                    </div>
                )}

                {data.employee && (
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <div>
                            <strong>Staff:</strong> {data.employee.firstName} {data.employee.lastName}
                        </div>
                        <Button
                            variant="outline-danger"
                            size="sm"
                            disabled={unlinking === 'employee'}
                            onClick={() => unlink('employee')}
                        >
                            {unlinking === 'employee' ? '...' : 'Unlink Employee'}
                        </Button>
                    </div>
                )}
            </Alert>
        </div>
    );
};

const ChannelLinkedEntities = (props) => (
    <ComponentErrorBoundary>
        <Component {...props} />
    </ComponentErrorBoundary>
);
export default ChannelLinkedEntities;
